import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface FormQuestionDto {
  id: string;
  text: string;
  textI18n: string | null;
  position: number;
}

export interface FormPageDto {
  id: string;
  name: string;
  nameI18n: string | null;
  position: number;
  questions: FormQuestionDto[];
}

@Injectable({ providedIn: 'root' })
export class FormPageService {
  private readonly http = inject(HttpClient);
  private readonly base = environment.apiUrl;

  getPages(establishmentId: string): Observable<FormPageDto[]> {
    return this.http.get<FormPageDto[]>(`${this.base}/api/v1/quality/forms/${establishmentId}/pages`);
  }

  createPage(establishmentId: string, name: string, nameI18n: Record<string, string>): Observable<FormPageDto> {
    return this.http.post<FormPageDto>(`${this.base}/api/v1/quality/forms/${establishmentId}/pages`, { name, nameI18n });
  }

  updatePage(establishmentId: string, pageId: string, name: string, nameI18n: Record<string, string>): Observable<void> {
    return this.http.put<void>(`${this.base}/api/v1/quality/forms/${establishmentId}/pages/${pageId}`, { name, nameI18n });
  }

  deletePage(establishmentId: string, pageId: string): Observable<void> {
    return this.http.delete<void>(`${this.base}/api/v1/quality/forms/${establishmentId}/pages/${pageId}`);
  }

  addQuestion(establishmentId: string, pageId: string, text: string, textI18n: Record<string, string>): Observable<FormQuestionDto> {
    return this.http.post<FormQuestionDto>(
      `${this.base}/api/v1/quality/forms/${establishmentId}/pages/${pageId}/questions`,
      { text, textI18n }
    );
  }

  deleteQuestion(establishmentId: string, pageId: string, questionId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.base}/api/v1/quality/forms/${establishmentId}/pages/${pageId}/questions/${questionId}`
    );
  }
}